@if (webAuthService.loggedIn) {
  <app-navbar #navbarComponent/>
  @if (navbarComponent.employee) {
    @if (!navbarComponent.unauthorized) {
      <router-outlet></router-outlet>
    }
  } @else {
    @if (navbarComponent.criticalFailure) {
      <div class="container mt-5">
        <div class="alert alert-danger">
          <p>
            Die Verbindung mit dem Server ist fehlgeschlagen. Bitte versuchen Sie es später erneut.
          </p>
        </div>
      </div>
    } @else if (navbarComponent.unauthorized) {
      <div class="container mt-5">
        <div class="alert alert-danger">
          <p>
            Sie sind im System nicht als rbb Mitarbeiterin oder Mitarbeiter hinterlegt und können daher rbb Forms nicht nutzen.
            Wenn Sie eine neue Mitarbeiterin oder ein neuer Mitarbeiter sind, warten Sie bitte bis die Personalabteilung Ihre Benutzerkontodaten zu Ihren Mitarbeiterdaten in SAP hinterlegt hat.
            Zuständig für die Pflege der Daten sind für freie Mitarbeiterinnen und Mitarbeiter die Honorarabrechnung (<a href="mailto:honorare@rbb-online.de">honorare&commat;rbb-online.de</a>) und für feste Mitarbeiterinnen und Mitarbeiter die Gehaltsabrechnung (<a href="mailto:gehalt@rbb-online.de">gehalt&commat;rbb-online.de</a>).
          </p>
          <p>Nachdem Ihre Daten in SAP aktualisiert wurden, kann <b>die Freischaltung bis zu einer Woche dauern.</b></p>
        </div>
      </div>
    } @else {
      <div class="m-5 text-center">
        <div class="m-5 text-center">
          <div class="d-flex justify-content-center mb-3">
            <rbb-loader size="lg"/>
          </div>
        </div>
        <div class="text-secondary pt-3 small">Benutzerdaten werden überprüft ...</div>
      </div>
    }
  }
} @else {
  <rbb-login/>
}
